import * as React from "react";
import { MenuItem, OutlinedInput } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
const StyledSelect = styled(Select)(({ theme }) => ({
    "&.MuiSelect-outlined": {
        backgroundColor: "red !important",
    },
}));
export default function CommonDropFamily(props) {
    const [value, setValue] = React.useState("");
    const [list] = React.useState(props.value);
    const handleChange = (event) => {
        setValue(event.target.value);
        props.selectCost(event.target.value, props.index);
    };
    React.useEffect(() => {
        setValue(list[0].category);
    }, []);
    return (React.createElement(FormControl, { sx: { m: 1, minWidth: 200 }, size: "small" },
        React.createElement(StyledSelect, { input: React.createElement(OutlinedInput, null), value: value, style: { backgroundColor: "#fff" }, onChange: (e) => handleChange(e) }, list.map((row, index) => (React.createElement(MenuItem, { value: row.category }, row.category))))));
}
